import { useEffect, useState } from "react";
import { usePublicServerData } from "../context/PublicServerDataContext";
import { getPublicSiteSettings } from "../services/publicContent.service";

// Default seguro: enquanto não sabemos, assumimos artigos habilitados (estado
// "nasce true") para não esconder a navegação por um flash durante o carregamento.
const DEFAULT_ARTICLES_ENABLED = true;

export function useSiteSettings() {
  const serverData = usePublicServerData();
  const serverSettings = serverData?.settings;
  const [articlesEnabled, setArticlesEnabled] = useState<boolean>(
    () => serverSettings?.articlesEnabled ?? DEFAULT_ARTICLES_ENABLED,
  );

  useEffect(() => {
    // Mantem a hidratacao consistente e revalida depois para nao prender um HTML cacheado antigo.
    if (serverSettings) {
      setArticlesEnabled(serverSettings.articlesEnabled);
    }

    let isMounted = true;
    getPublicSiteSettings()
      .then((settings) => {
        if (isMounted) {
          setArticlesEnabled(settings.articlesEnabled);
        }
      })
      .catch(() => {
        if (isMounted && !serverSettings) {
          setArticlesEnabled(DEFAULT_ARTICLES_ENABLED);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [serverSettings]);

  return { articlesEnabled };
}
